import { Drawer, Typography } from "@mui/material";
import React, { useState } from "react";
import "./menudrawer.scss";
import closeIcon from "../../../assets/images/closeIcon.svg";
import shieldCheckMark from "../../../assets/images/shieldCheckMark.svg";
import privacyIcon from "../../../assets/images/privacyIcon.svg";
import termAndCondition from "../../../assets/images/termAndCondition.svg";
import aboutUs from "../../../assets/images/aboutUs.svg";
import contactSupport from "../../../assets/images/contactSupport.svg";
import logout from "../../../assets/images/lagout.svg";
import forwardArrow from "../../../assets/images/forwardArrow.svg";
import { getParams } from "../../../utlis/helpers";
import {
  getPrivacyPolicyUrl,
  getTermsUrl,
  getAboutUsUrl,
  getContactUsUrl,
} from "../../../configs/environment";
import { Link } from "react-router-dom";
import LogoutConfirmation from "../../modals/LogoutConfirmation";
import { useDispatch } from "react-redux";
import { setAPILoader } from "../../../state/actions/globalAction";
import { pageLocale } from "../../../utlis/locale";

const MenuDrawer = ({ openMenuDrawer, setOpenMenuDrawer, user }) => {
  const { locale } = getParams();
  const [logoutPopUp, setLogoutPopUp] = useState(false);
  const dispatch = useDispatch();
  const {
    privacy_policy,
    subtitle_privacy_policy,
    terms_Condition,
    subtitle_terms_condition,
    about_us,
    subtitle_about_us,
    contact_support,
    subtitle_contact_us,
    logouttext,
    subtitle_logout,
  } = pageLocale("landing");
  const menuListItem = [
    {
      icon: privacyIcon,
      header: privacy_policy,
      description: subtitle_privacy_policy,
      link: getPrivacyPolicyUrl(locale),
    },
    {
      icon: termAndCondition,
      header: terms_Condition,
      description: subtitle_terms_condition,
      link: getTermsUrl(locale),
    },
    {
      icon: aboutUs,
      header: about_us,
      description: subtitle_about_us,
      link: getAboutUsUrl(locale),
    },
    {
      icon: contactSupport,
      header: contact_support,
      description: subtitle_contact_us,
      link: getContactUsUrl(locale),
    },
    {
      icon: logout,
      header: logouttext,
      description: subtitle_logout,
    },
  ];
  const logoputHandler = (x, url) => {
    if (x === logouttext) {
      setOpenMenuDrawer(false);
      setLogoutPopUp(true);
    } else {
      dispatch(setAPILoader(true));
      setOpenMenuDrawer(false);
      window.location.href = url;
      dispatch(setAPILoader(false));
    }
  };

  return (
    <>
      <Drawer
        anchor={"left"}
        open={openMenuDrawer}
        onClose={setOpenMenuDrawer}
        className="menu-drawer-wrapper"
      >
        <div className="main-wrap">
          <div className="close-wrapper">
            <img
              src={closeIcon}
              className="close-icon"
              onClick={setOpenMenuDrawer}
              alt="close"
            />
          </div>
          <div className="menu-header-wrapper">
            <img src={user?.picture} alt="user" className="user-icon" />
            <div className="header-title-wrapper">
              <div className="sub-header-menu">
                <Typography className="title">{user?.name}</Typography>
                <div className="abc"> </div>
                <img src={shieldCheckMark} alt="checkmark" />
              </div>
              <Typography className="email-info">{user?.email}</Typography>
            </div>
          </div>
          <div className="dashed-line" />
          {menuListItem.map((item, index) => {
            return (
              <Link
                to={item.header !== "Logout" && item?.link}
                key={index}
                className="navigate-block"
                onClick={(e) => {
                  e.preventDefault();
                  logoputHandler(item.header, item?.link);
                }}
              >
                <div
                  className="menu-list-wrapper"
                  onClick={(e) => {
                    e.preventDefault();
                    logoputHandler(item.header, item?.link);
                  }}
                >
                  <div className="menu-item">
                    <img src={item.icon} alt="icon" />
                    <div className="menu-item-header">
                      <Typography className="title">{item.header}</Typography>
                      <Typography className="info">
                        {item.description}
                      </Typography>
                    </div>
                  </div>
                  <div>
                    {/* <Link to={item.header !== "Logout" && item.link}> */}
                    <img src={forwardArrow} alt="arrow" />
                    {/* </Link> */}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </Drawer>
      <LogoutConfirmation setlogout={setLogoutPopUp} logout={logoutPopUp} />
    </>
  );
};

export default MenuDrawer;
